import Lottie from 'react-lottie-player'

import { Text } from '@percent/lemonade'
import type { AILoaderProps } from './ai-loader.types'
import classes from './ai-loader.module.css'

const ANIMATION_PATH =
  'https://static.poweredbypercent.com/giving/aiLoader.json'

export function AILoader({ title, subtitle }: Readonly<AILoaderProps>) {
  return (
    <div className={classes.container} data-testid="ai-loader">
      <div className={classes.animationContainer}>
        <Lottie play loop path={ANIMATION_PATH} />
      </div>
      <Text size="large" fontWeight="semiBold">
        {title}
      </Text>
      <Text size="small">{subtitle}</Text>
    </div>
  )
}
